export const setItemToStorage = (key: string, val: any) => {
  localStorage.setItem(key, JSON.stringify(val));
};

export const getItemfromStorage = (key: string) => {
  return JSON.parse(localStorage.getItem(key) || '{}');
};
//expects a stringified string
export const getMultiLineString = (val: any) => {
  if (isStringified(val) && typeof val === 'string') {
    return JSON.parse(val.replace('\\n', '<br>'))
      .toString()
      .replace('<br>', '\n');
  } else {
    return val;
  }
};

//expects a stringified string
export const getMultiLineStringForDisplayInGrid = (val: any) => {
  if (isStringified(val)) return JSON.parse(val.replace('\\n', ' '));
  else return val;
};

export const isStringified = (val: any) => {
  try {
    JSON.parse(val);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Formats a timestamp for display in a grid cell.
 *
 * The APIs return timestamps as epoch millis (Jackson's default for java.sql.Timestamp; the
 * backend deliberately does NOT set @JsonFormat because Jackson's default zone is UTC and would
 * shift every value). Formatting here renders in the viewer's own zone, which is what the rest of
 * the portal does. Returns "" for null/empty so grid cells stay blank rather than showing "NaN".
 */
export const formatDateTime = (value: any): string => {
  if (value === null || value === undefined || value === '') return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);
  const pad = (n: number) => (n < 10 ? '0' + n : String(n));
  const meridiem = d.getHours() >= 12 ? 'PM' : 'AM';
  const hours = d.getHours() % 12 || 12;
  return (
    pad(d.getDate()) +
    '-' +
    pad(d.getMonth() + 1) +
    '-' +
    d.getFullYear() +
    ' ' +
    pad(hours) +
    ':' +
    pad(d.getMinutes()) +
    ' ' +
    meridiem
  );
};
